import { api } from '@/config/api';

export type CatalogKind = 'product' | 'service';

export interface CatalogItem {
  itemUid: string;
  name: string;
  description: string | null;
  category: string;
  kind: CatalogKind;
  /** null = free / price on request. */
  price: number | null;
  currency: string | null;
  imageUrl: string | null;
  sku: string | null;
  isAvailable: boolean;
  tags: string[];
  durationMinutes: number | null;
  bookable: boolean;
  apptServiceUid: string | null;
  sortOrder: number;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface CatalogCategory { category: string; count: number; available: number }

export interface CatalogSummary {
  items: CatalogCategory[];
  uncategorised: number;
  totals: { items: number; available: number; bookable: number; categories: number };
}

export interface CatalogListParams {
  q?: string;
  category?: string;
  kind?: CatalogKind;
  available?: 'true' | 'false';
  bookable?: 'true' | 'false';
  page?: number;
  limit?: number;
}

export interface CatalogItemInput {
  name?: string;
  description?: string;
  category?: string;
  kind?: CatalogKind;
  price?: number | null;
  currency?: string;
  imageUrl?: string;
  sku?: string;
  isAvailable?: boolean;
  tags?: string[];
  durationMinutes?: number | null;
  bookable?: boolean;
  apptServiceUid?: string;
}

export const catalogService = {
  list: async (params: CatalogListParams = {}): Promise<{ items: CatalogItem[]; total: number; page: number; limit: number }> =>
    (await api.get('/slighter_crm/catalog', { params })).data,
  categories: async (): Promise<CatalogSummary> => (await api.get('/slighter_crm/catalog/categories')).data,
  get: async (itemUid: string): Promise<CatalogItem> => (await api.get(`/slighter_crm/catalog/${itemUid}`)).data,
  create: async (input: CatalogItemInput): Promise<CatalogItem> => (await api.post('/slighter_crm/catalog', input)).data,
  update: async (itemUid: string, input: CatalogItemInput): Promise<CatalogItem> =>
    (await api.patch(`/slighter_crm/catalog/${itemUid}`, input)).data,
  remove: async (itemUid: string): Promise<void> => { await api.delete(`/slighter_crm/catalog/${itemUid}`); },
  setAvailability: async (itemUids: string[], isAvailable: boolean): Promise<{ matched: number; modified: number }> =>
    (await api.patch('/slighter_crm/catalog/availability', { itemUids, isAvailable })).data,
  reorder: async (itemUids: string[]): Promise<void> => { await api.patch('/slighter_crm/catalog/reorder', { itemUids }); },
};
